(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-contabilidad-emitidas', {
                parent: 'entity',
                url: '/consortium-contabilidad-emitida?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumContabilidadEmitida'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas.html',
                        controller: 'ConsortiumContabilidadEmitidaController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-contabilidad-emitidas.new', {
                parent: 'consortium-contabilidad-emitidas',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas-new.html',
                        controller: 'ConsortiumContabilidadEmitidaNewController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nuevo',
                    parent: 'consortium-contabilidad-emitidas'
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-contabilidad-emitidas',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            }).state('consortium-contabilidad-emitidas.edit', {
                parent: 'consortium-contabilidad-emitidas',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumContabilidadEmitida'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas-detail.html',
                        controller: 'ConsortiumContabilidadEmitidaDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Lista',
                    parent: 'consortium-contabilidad-emitidas'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumContabilidadEmitida', function ($stateParams, ConsortiumContabilidadEmitida) {
                        return ConsortiumContabilidadEmitida.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-contabilidad-emitidas',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
